import { render, staticRenderFns } from "./DropshipperOrders.vue?vue&type=template&id=06e3b343&scoped=true"
import script from "./DropshipperOrders.vue?vue&type=script&lang=js"
export * from "./DropshipperOrders.vue?vue&type=script&lang=js"
import style0 from "./DropshipperOrders.vue?vue&type=style&index=0&id=06e3b343&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3b343",
  null
  
)

export default component.exports